function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-524.000000, -320.000000) translate(252.000000, 40.000000) translate(24.000000, 240.000000) translate(0.000000, 24.000000) translate(192.000000, 0.000000) translate(45.000000, 16.000000) translate(11.633094, 0.000000) translate(4.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.841,
  cy: 33.799,
  fill: "#FFB511",
  rx: 16.08,
  ry: 16
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.97,
  cy: 33.08,
  fill: "#6BA5B4",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.324,
  cy: 25.204,
  fill: "#6BA5B4",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.452,
  cy: 7.11,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.764,
  cy: 12.602,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.866,
  cy: 10.667,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.373,
  cy: 15.999,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.499,
  cy: 13.39,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.507,
  cy: 1.778,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.38,
  cy: 22.841,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 29.931,
  cy: 4.726,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.561,
  cy: 4.747,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.08,
  cy: 7.111,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.741,
  cy: 48.832,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.787,
  cy: 40.888,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.211,
  cy: 9.452,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 21.282,
  cy: 6.301,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.865,
  cy: 55.111,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.734,
  cy: 8.888,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.734,
  cy: 15.752,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.566,
  cy: 11.027,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 50.276,
  cy: 42.532,
  fill: "#6BA5B4",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.691,
  cy: 44.895,
  fill: "#6BA5B4",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32.159,
  cy: 55.111,
  fill: "#6BA5B4",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.653,
  cy: 44.444,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.983,
  cy: 24.416,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.734,
  cy: 17.777,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.799,
  cy: 58.667,
  fill: "#FFB511",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 49.598,
  cy: 29.142,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.195,
  cy: 8.889,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.518,
  cy: 17.41,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 35.915,
  cy: 23.628,
  fill: "#0F1941",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.88,
  cy: 62.222,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 54.213,
  cy: 40.957,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.88,
  cy: 19.556,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.773,
  cy: 12.445,
  fill: "#E74536",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.942,
  cy: 18.903,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.013,
  cy: 33.868,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.726,
  cy: 21.266,
  fill: "#2175D9",
  rx: 1.787,
  ry: 1.778
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F5F0",
  d: "M6.254 8.89H4.467v-8c0-.36-.218-.685-.551-.822-.334-.138-.719-.062-.974.192L.262 2.927c-.35.347-.35.91 0 1.258.349.347.914.347 1.264 0l1.155-1.15v5.854H.894c-.493 0-.893.399-.893.89 0 .49.4.888.893.888h5.36c.493 0 .893-.398.893-.889s-.4-.889-.893-.889z",
  transform: "translate(23.230036, 28.444192)"
}))))))))));
function SvgTypeFirst({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFirst);
export default __webpack_public_path__ + "static/media/TypeFirst.dc13e6d16874483d2502d5acf32285a8.svg";
export { ForwardRef as ReactComponent };